import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Page from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import Spacer from '../../components/Spacer';


// import useBasisCash from '../../hooks/useBasisCash';

import moment from 'moment'
import Notice from '../../components/Notice';
// import useArticles,{ useArticle, useHotWords  } from '../../hooks/useArticles';
// import { HTMLText, Question } from '../Home/components/Question'
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash'
// import { Article } from '../Home/components/Article';
import { useHistory, useParams } from 'react-router-dom';
import useDelayShow from '../../hooks/useDelayShow';
import { Spin,Button, Tree, Table, Collapse, Space, message, } from 'antd';
import DocumentTitle from 'react-document-title'
import cheerio from 'cheerio'
import {BsDownload} from 'react-icons/bs'
// import { downloadPageCanvas, getOwner, getThemeData, isAuthorized } from '../../utils/util';
// import useWaterMark from '../../hooks/useWaterMark';
import sleep from 'sleep-promise';
import { FcLock } from 'react-icons/fc';
import copy from 'copy-to-clipboard';
import stores from '../../state';
// import BackToActivate from '../../components/BackToActivate';
import { StyledTopBar, StyledTopBarInner } from '../../components/TopBar/TopBar';
import Container from '../../components/Container';
import { LeftOutlined } from '@ant-design/icons'
import en from './img/en.png'
import hd from './img/hd.png'
import { MdRadioButtonUnchecked } from "react-icons/md";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useTranslation } from 'react-i18next';
import theme from '../../theme';
import { useLanguages } from '../../components/LotterySegmentTab/LotterySegmentTab';
  
const Item:React.FC<{languageIcon:any,language:string,checked:boolean,cb:(lan:'en'|'hd')=>void}> = ({languageIcon,language,checked,cb})=>{
    return  <div style={{display:'flex',justifyContent:'space-between',width:'calc( 100% - 20px)',background:'white',borderRadius:10,padding:10,marginTop:10}}
    onClick={()=>cb?.(language === 'English'?'en':'hd')}
        >
        <span style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            <img src={languageIcon} style={{width:30,height:20}} alt=''/>
            <span style={{marginLeft:10,}}>{language}</span>
        </span>
        <span style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
            {/* <span style={{marginRight:10,fontWeight:'bold'}}>English</span> */}
            {checked?<IoIosCheckmarkCircle style={{color:theme.color.primary.main,fontSize:30}}/>:<MdRadioButtonUnchecked style={{color:'#efefef',fontSize:30}}/>}
            
        </span>
    </div>
}


export const useInitLanguage = ()=>{
    const languages = useLanguages()
    const {setLanguage} = useSetLanguage()
    useEffect(()=>{
      const storedLangIndex = stores.TodoList.langIndex
    //   if(storedLangIndex!=langIndex){
        // setLangIndex(storedLangIndex)
        setLanguage(languages[storedLangIndex]?.langCode)
    //   }
    },[])
}
export const useSetLanguage = ()=>{
    const {i18n} = useTranslation()
    const setLanguage = useCallback((lan)=>{
        i18n.changeLanguage(lan)
        console.log('i18n',i18n.language,i18n.languages)
    },[]) 
    return {setLanguage}
}
const Practice: React.FC = () => {  
  const history = useHistory()
//   const show = useDelayShow(10)
//   if(!show){
//       return <div/>
//   }
    const {setLanguage} = useSetLanguage()
    useEffect(()=>{
        console.log('i18n.language',i18n.language)
        if(i18n.language !== 'en' && i18n.language !=='hd'){
            setLanguage('en')
        }
    },[])
    const {t,i18n} = useTranslation()
    // const setLanguage = useCallback((lan)=>{
    //     i18n.changeLanguage(lan)
    //     console.log('i18n',i18n.language,i18n.languages)
    // },[]) 
  // console.log('rawData',rawData)
   return <Page showTopBar={false}>
     <DocumentTitle title='Language'/>
     <StyledTopBar>
    <Container size="lg">
        <StyledTopBarInner>
        <div style={{width:50,marginLeft:10}}>
            <LeftOutlined onClick={()=>history.goBack()}/>
        </div>
        <div>{t('language')}</div>
        <div style={{width:50,marginRight:10,fontSize:10, display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
            
        </div>
        </StyledTopBarInner>
    </Container>
    
    </StyledTopBar>  
    <div style={{background:'#efefef',width:'100%',display:'flex',flexDirection:'column',alignItems:'center',height:'100%',flex:1}}>
        <Spacer size='lg'/>
        <Spacer size='sm'/>
        <Item languageIcon={en} language='English' checked={i18n.language==='en'} cb={setLanguage}/>
        <Item languageIcon={hd} language='हिंदी' checked={i18n.language==='hd'} cb={setLanguage}/> 
    </div>
  </Page>
};
 
export default Practice;
